export default {
  production: null,
  warehouse: null,
  pricesPopup: {
    system: '',
    model: '',
    id: null,
  },
  prices: {
    dealer: null,
    supplier: null,
  },
  charge: {
    systemIndex: null,
    modelIndex: null,
    subIndex: null,
    id: '',
  }
}
